import { useMutation } from "react-query";
import { editOperationsGroup } from "actions/Utilities/OperationsGroup";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  editStateOperationsGroup,
  operationsGroupReFetching,
} from "../atoms/atoms";
import { IOperationsGroup } from "../types";
import { toast } from "components/toastNotification";

const useEditOperationsGroup = () => {
  // return useMutation(editOperationsGroup);
  
  const setActionEditState = useSetRecoilState(editStateOperationsGroup);
  const [isReFetching, setIsReFetching] = useRecoilState(
    operationsGroupReFetching
  );

  const { mutate } = useMutation(
    (newData: IOperationsGroup) => editOperationsGroup(newData),
    {
      onSuccess: (res) => {

        if (typeof res == "object") {
          toast.fire(
            "Updating Operations Group failed",
            `${res.Message}`,
            "error"
          );
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Operations Group Updated Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Operations Group Updated Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Updating Operations Group failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Updating Operations Group failed ",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            case res.includes("Action object"):
              toast.fire(
                "Updating Operations Group failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire(
                "Updating Operations Group failed",
                `${res}`,
                "error"
              );
          }
        }
        setActionEditState(false);
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error: any) => {
        toast.fire(
          "Update Operations Group failed",
          `Error: ${error}`,
          "error"
        );
      },
    }
  );
  return mutate;
};

export default useEditOperationsGroup;
